// Objekt-Widgets (README §7). Reihenfolge innerhalb der Gruppen wie im Prototyp,
// Beschriftungen wie in „Widgets anpassen“. panel = Schlüssel für ?panel=…
// 'einheiten' ist kein Panel, sondern der Einheiten-Tab.

import type { GruppenKey, WidgetDef } from '../../lib/immobilien/widgetRaster';
import type { VerwaltungsartKurz } from '../../lib/immobilien/sidebarNav';
import type { ObjektPanelKey } from './objektPanels';
import type { WidgetGroesse } from './ui/Widget';

export type ObjektWidgetKey =
  | 'hero' | 'Stamm' | 'Beleg' | 'Karte' | 'Flaeche' | 'Einheiten'
  | 'Kalt' | 'Mieten' | 'Ehem' | 'Mahn' | 'Mieterh' | 'Keys' | 'Kontakte'
  | 'Weg' | 'Finanzen' | 'Wplan' | 'Grund' | 'Bank'
  | 'Zaehler' | 'Tickets' | 'Wartung' | 'Vertraege' | 'Versich' | 'Dienstleister'
  | 'Zust' | 'Termine' | 'Eigent' | 'Etv' | 'Protokoll' | 'Notizen' | 'Dokumente' | 'Aliase';

export interface ObjektWidgetDef extends WidgetDef<ObjektWidgetKey> {
  groesse: WidgetGroesse;
  panel: ObjektPanelKey | 'einheiten' | null;
  nur?: 'weg' | 'nichtWeg';
}

const W = (key: ObjektWidgetKey, label: string, gruppe: GruppenKey, groesse: WidgetGroesse, panel: ObjektWidgetDef['panel'], nur?: ObjektWidgetDef['nur']): ObjektWidgetDef =>
  ({ key, label, gruppe, groesse, panel, nur });

export const OBJEKT_WIDGETS: readonly ObjektWidgetDef[] = [
  W('hero', 'Objektfoto', 'ueb', 'gross', null),
  W('Stamm', 'Technik & Stammdaten', 'ueb', 'breit', 'stamm'),
  W('Beleg', 'Belegung', 'ueb', 'normal', 'beleg'),
  W('Karte', 'Karte', 'ueb', 'breit', 'karte'),
  W('Flaeche', 'Fläche', 'ueb', 'normal', 'flaeche'),
  W('Einheiten', 'Einheiten', 'ueb', 'gross', 'einheiten'),
  W('Kalt', 'Kaltmiete', 'verm', 'normal', 'kalt'),
  W('Mieten', 'Mieteingang', 'verm', 'breit', 'mieten'),
  W('Ehem', 'Ehemalige', 'verm', 'normal', 'ehem'),
  W('Mahn', 'Mahnwesen', 'verm', 'normal', 'mahn'),
  W('Mieterh', 'Mieterhöhung', 'verm', 'normal', 'mieterh', 'nichtWeg'),
  W('Keys', 'Schlüssel', 'verm', 'normal', 'keys'),
  W('Kontakte', 'Kontakte', 'verm', 'normal', 'kontakte'),
  W('Weg', 'MEA & Hausgeld', 'fin', 'breit', 'weg', 'weg'),
  W('Finanzen', 'Finanzen', 'fin', 'breit', 'finanzen'),
  W('Wplan', 'Rücklage', 'fin', 'normal', 'wplan', 'weg'),
  W('Grund', 'Grundsteuer', 'fin', 'normal', 'grund'),
  W('Bank', 'Konten', 'fin', 'normal', 'bank'),
  W('Zaehler', 'Zähler', 'tech', 'breit', 'zaehler'),
  W('Tickets', 'Tickets', 'tech', 'breit', 'tickets'),
  W('Wartung', 'Prüfungen', 'tech', 'normal', 'wartung'),
  W('Vertraege', 'Verträge', 'tech', 'normal', 'vertraege'),
  W('Versich', 'Versicherungen', 'tech', 'normal', 'versich'),
  W('Dienstleister', 'Dienstleister', 'tech', 'breit', 'dienstleister'),
  W('Zust', 'Zuständig', 'recht', 'normal', 'zust'),
  W('Termine', 'Termine', 'recht', 'normal', 'termine'),
  W('Eigent', 'Eigentümer', 'recht', 'breit', 'eigent'),
  W('Etv', 'ETV & Beschlüsse', 'recht', 'normal', 'etv', 'weg'),
  W('Protokoll', 'Aktivität', 'recht', 'breit', 'protokoll'),
  W('Notizen', 'Notizen', 'recht', 'normal', 'notizen'),
  W('Dokumente', 'Dokumente', 'recht', 'breit', 'dokumente'),
  W('Aliase', 'KI-Aliase', 'recht', 'normal', 'aliase'),
];

/** Für die Verwaltungsart angebotene Widgets (WEG-Widgets nur bei WEG, Mieterhöhung nicht bei WEG). */
export function objektWidgetsFuer(va: VerwaltungsartKurz | null): ObjektWidgetDef[] {
  const weg = va === 'WEG';
  return OBJEKT_WIDGETS.filter(w => !w.nur || (w.nur === 'weg' ? weg : !weg));
}
